
import axios from 'axios'
/**
 * 
 * @param {String} handle - prodcut handle
 * @returns {Function} -  aysnc function that returns a promise of product data for the handle
 */
const axiosGetFullProductJSON = (handle) => {
  return async () => {
    const res = await axios.get(`/products/${handle}.js`);
    if (res) {
      return res.data
    }
  }
}

export default axiosGetFullProductJSON
